import React, {Component} from 'react';
import AnswerScreen from './AnswerScreen.jsx';
import VotingScreen from './VotingScreen.jsx';
import HintDisplay from  './HintDisplay.jsx';
import WaitScreen from '../WaitingScreen.jsx';
import DebateScreen from '../DebateScreen.jsx'
import ListenScreen from '../ListenScreen.jsx'
import DiscussScreen from '../DiscussScreen.jsx';

export default class OpenQuestionHandler extends Component {
    constructor(props) {
        super(props);

    }
    render(){
        let viewComponent = "";
        let viewName = this.props.information.view.split('.').slice(-1)[0];
        switch(viewName){
            //openQuestion.hint
            case("hint"):
                viewComponent = (
                    <HintDisplay
                        information={this.props.information}
                        module="openQuestion"
                        exitGame={this.props.exitGame}
                    />
                );
                break;
            //openQuestion.answer
            case("answer"):
                viewComponent = (
                    <AnswerScreen
                        information={this.props.information}
                        sendSocketMessage={this.props.sendSocketMessage}
                        module="openQuestion"
                        exitGame={this.props.exitGame}
                    />
                );
                break;
            //openQuestion.vote
            case("vote"):
                viewComponent = (
                    <VotingScreen
                        information={this.props.information}
                        sendSocketMessage={this.props.sendSocketMessage}
                        module="openQuestion"
                        exitGame={this.props.exitGame}
                    />
                );
                break;
            //openQuestion.listen
            case("listen"):
                viewComponent = (
                    <ListenScreen
                        information={this.props.information}
                        sendSocketMessage={this.props.sendSocketMessage}
                        module="openQuestion"
                        exitGame={this.props.exitGame}
                    />
                );
                break;
            //openQuestion.debate
            case("debate"):
                viewComponent = (
                    <DebateScreen
                        information={this.props.information}
                        sendSocketMessage={this.props.sendSocketMessage}
                        module="openQuestion"
                        exitGame={this.props.exitGame}
                    />
                );
                break;
            //openQuestion.wait
            case("wait"):
                viewComponent = (
                    <WaitScreen
                        information={this.props.information}
                        sendSocketMessage={this.props.sendSocketMessage}
                        module="openQuestion"
                        exitGame={this.props.exitGame}
                    />
                );
                break;
            //openQuestion.discuss
            case("discuss"):
                viewComponent = (
                    <DiscussScreen
                        information={this.props.information}
                        sendSocketMessage={this.props.sendSocketMessage}
                        module="openQuestion"
                        exitGame={this.props.exitGame}
                    />
                );
                break;
        }
            return (
                <div>
                    {viewComponent}
                </div>
            );
    }
}